import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { IoCloseCircle } from 'react-icons/io5';
import { BiMenu } from 'react-icons/bi';

const Layout = ({ children }) => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen((prev) => !prev);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar
        isDrawerOpen={isDrawerOpen}
        onDrawerToggle={handleDrawerToggle}
        className={`fixed inset-y-0 left-0 z-30 w-64 bg-blue-600 text-white p-4 transform ${
          isDrawerOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-transform duration-300 md:relative md:translate-x-0 md:w-1/4 lg:w-1/5`}
      />

      {/* Overlay for mobile view */}
      {isDrawerOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-20 md:hidden"
          onClick={handleDrawerToggle}
        />
      )}

      {/* Main Content */}
      <div className="flex flex-col flex-grow transition-all duration-300 w-full md:w-3/4 lg:w-4/5">
        <header className="p-4 bg-gray-800 text-white flex justify-between items-center md:hidden">
          <button onClick={handleDrawerToggle}>
            {isDrawerOpen ? <IoCloseCircle className="w-6 h-6" /> : <BiMenu className="w-6 h-6" />}
          </button>
          <h1 className="text-xl font-bold">My App</h1>
        </header>
        <main className="flex-1 p-6 overflow-y-scroll">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
